import { Pipe, PipeTransform, inject } from '@angular/core'
import { Maybe, StorageProductStatus } from '@generated/sammathnaur.graphql'
import { TranslateService } from '@ngx-translate/core'
import { constantCase } from 'change-case'

@Pipe({
    name: 'translateStorageProductStatus',
    standalone: false
})
export class TranslateStorageProductStatusPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService)

  public transform(productMeasure?: Maybe<StorageProductStatus>): string {
    return this.translateService.instant(`TRANSLATE_STORAGE_PRODUCT_STATUS.${constantCase(productMeasure || StorageProductStatus.Unknown)}`)
  }
}
